module.exports = __webpack_public_path__ + "static/img/Brodie_Grundy_desktop.46533ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brodie_Grundy_desktop.jpg
// module id = Xe9E
// module chunks = 0